import { useTranslation } from 'react-i18next'
import { SubscriptionManagementSection } from '../components/account/SubscriptionManagementSection.tsx'
import { ChangePasswordSection } from '../components/account/ChangePasswordSection.tsx'
import { AccountDeletionSection } from '../components/account/AccountDeletionSection.tsx'

export function SettingsPage() {
  const { t } = useTranslation()

  return (
    <main className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-4xl font-bold mb-2">
          {t('settings.title')}
        </h1>
        <p className="text-sm sm:text-base text-[#6D6D6D]">
          {t('settings.description')}
        </p>
      </div>

      <div className="max-w-2xl space-y-6">
        <SubscriptionManagementSection />
        <ChangePasswordSection />
        <AccountDeletionSection />
      </div>
    </main>
  )
}
